import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                  91视频
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                高清视频免费播放平台，海量资源随心看，随时随地享受极致视频体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">视频分类</h4>
              <ul className="space-y-2">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">更多分类</h4>
              <ul className="space-y-2">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                    联系我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap" rel="nofollow">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap" rel="nofollow">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-sm text-background-500">
              &copy; 2026 91视频在线观看 版权所有 | 高清视频免费播放平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}